//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { goSlotGame } from "@/common/utils/common.js";
import { mapMutations } from "vuex";
export default {
  props: {
    gameType: {
      type: String,
      required: true,
    },
    list: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {};
  },
  created() {},
  methods: {
    ...mapMutations(["SET_LOGIN_SHOW"]),
    handleGoGame(item) {
      // 点击游戏
      // popularType 热门类型0=平台，1=游戏
      // 游戏类型:1 - 电子，2-真人，3-体育，4-彩票，5-捕鱼，6-棋牌

      if (this.$store.state.isLogin) {
        goSlotGame(
          item,
          this.$store.state.isLogin,
          this.$store.state.UUID,
          this.$router
        );
      } else {
        this.SET_LOGIN_SHOW();
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/build800/views/game/item/index.vue